import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-qc-bg text-qc-text flex flex-col items-center justify-center p-5">
      <div className="text-center max-w-sm" data-testid="not-found-page">
        {/* 404 Display */}
        <div className="mb-6">
          <span className="text-8xl font-black text-qc-green tracking-tighter">404</span>
        </div>

        <h1 className="text-2xl font-extrabold text-qc-text mb-2">
          Page not found
        </h1>
        <p className="text-qc-text-dim mb-8">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>

        {/* Action buttons */}
        <div className="space-y-3">
          <Button
            asChild
            className="w-full h-12 bg-qc-green hover:bg-qc-green-dark text-qc-bg rounded-xl font-extrabold"
            data-testid="go-home-button"
          >
            <Link to="/home">
              <Home className="w-5 h-5 mr-2" />
              Go to Home
            </Link>
          </Button>
          
          <Button
            asChild
            variant="outline"
            className="w-full h-12 bg-qc-surface border-qc-border text-qc-text hover:bg-qc-surface2 rounded-xl font-bold"
            data-testid="go-back-button"
          >
            <Link to="/login">
              <ArrowLeft className="w-5 h-5 mr-2" />
              Back to Login
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
